export default "__VITE_ASSET__Dp9xKBDN__"